module.exports = __webpack_public_path__ + "img/emptylogo.2d204e63.png";